import { graphql } from '@/gql'

export const WORKER_VIEW_FRAGMENT = graphql(/* GraphQL */ `
  fragment WorkerViewFragment on Worker {
    id
    name
    email
    phone
    address {
      city
      state
      country {
        isoCode
        name
      }
    }
    initials
    avatar
    avatarPath @client
    jobTitle
    market {
      code
      name
    }
    currency
    dayRate
    skills {
      id
      name
    }
    totalPaid(account: $companyId)
    isCurrentlyHired(account: $companyId)
    viewerCanContact(account: $companyId)
    viewerCanOfferJob(account: $companyId)
    hires(companies: [$companyId], isAccepted: true) {
      paginatorInfo {
        total
      }
    }
    pendingHires: hires(companies: [$companyId], isAccepted: false) {
      paginatorInfo {
        total
      }
    }
    activeHires: hires(companies: [$companyId], isAccepted: true, status: ACTIVE) {
      paginatorInfo {
        total
      }
      data {
        id
        createdAt
        job {
          id
          name
        }
        company {
          name
        }
        paymentRequests {
          data {
            id
            number
          }
        }
      }
    }
    completedHires: hires(companies: [$companyId], isAccepted: true, status: COMPLETED) {
      data {
        id
        createdAt
        job {
          id
          name
        }
        company {
          name
        }
        paymentRequests {
          data {
            id
            number
          }
        }
      }
    }
    primaryBusinessEntity {
      name
    }
    profile {
      url
      links {
        title
        url
      }
    }
    hiresWithAttribution {
      recruiter {
        name
      }
      recruiterFee
      recruiterManagesWorkers
      recruiterOwnershipStartDate
      recruiterOwnershipDays
      recruiterOwnershipDaysLeft
    }
  }
`)

export const TRUSTED_CONTACT_VIEW_FRAGMENT = graphql(/* GraphQL */ `
  fragment TrustedContactViewFragment on TrustedContact {
    id
    company {
      name
    }
    externalIdentifier
    links
    attachments {
      name
      url
    }
    skills {
      id
      name
    }
    status
    statusUpdatedAt
    notes {
      paginatorInfo {
        total
      }
    }
    viewerCanApprove(account: $companyId)
    viewerCanUpdate(account: $companyId)
    viewerCanDelete(account: $companyId)
    viewerCanReInvite(account: $companyId)
    invitedAt
    invitedByUser {
      name
    }
    worker {
      ...WorkerViewFragment
    }
    customFieldValues {
      ...CustomFieldValuesView
    }
  }
`)

export const CONVERSATIONS_VIEW_FRAGMENT = graphql(/* GraphQL */ `
  fragment ConversationsViewFragment on Conversation {
    id
    subject
    url
    createdAt
    latestMessage {
      author {
        name
      }
    }
  }
`)

export const TRUSTED_CONTACTS_NOTES_FRAGMENT = graphql(/* GraphQL */ `
  fragment TrustedContactNotesFragment on TrustedContact {
    id
    notes(first: 100) {
      data {
        ...NoteViewFragment
      }
      paginatorInfo {
        total
      }
    }
  }
`)
